import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import i18next from "i18next";
import { Product } from "./Interfaces";

export interface ExcelProduct extends Omit<Product, 'category'> {
	categoryName: string;
	errors?: string[];
}

interface ProductSimpleTableProps {
	products: ExcelProduct[];
	startRowIndex?: number;
	fontSize?: string;
}

export const ProductSimpleTable = (props: ProductSimpleTableProps) => {
	const { products: ps, startRowIndex = 1, fontSize = '0.8rem' } = props;

	const confirmDialogFontSize = fontSize;

	const columns = [
		{ key: 'rowNumber', label: i18next.t('common.row_number'), width: 70, align: 'center' },
		// { key: 'categoryName', label: i18next.t('product_category.product_type'), width: 70, align: 'center' },
		{ key: 'curriculumName', label: i18next.t('product.curriculum_name'), width: 100 },
		{ key: 'volume', label: i18next.t('product.volume'), width: 50, align: 'center' },
		{ key: 'title', label: i18next.t('common.title'), width: 140 },
		{ key: 'code', label: i18next.t('product.subject_code'), width: 140 },
		{ key: 'price', label: i18next.t('product.price'), align: 'right' }
	];

	return (
		<TableContainer>
			<Table size="small">
				<TableHead>
					<TableRow>
						{columns.map(column => (
							<TableCell
								key={column.key}
								sx={{
									minWidth: column.width,
									textAlign: column.align || 'left',
									fontSize: confirmDialogFontSize,
									fontWeight: 'bold'
								}}
							>
								{column.label}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{ps.map((product, index) => (
						<TableRow key={index}>
							{columns.map(column => {
								const { errors } = product;
								const bgColor = errors?.includes(column.key) ? 'rgba(255, 0, 0, 0.1)' : 'transparent';

								return (
									<TableCell
										key={column.key}
										sx={{
											backgroundColor: bgColor,
											textAlign: column.align || 'left',
											fontSize: confirmDialogFontSize
										}}
									>
										{column.key === 'rowNumber' ? index + startRowIndex :
											column.key === 'price' && product[column.key] ?
												i18next.t('common.price_yen', { price: product[column.key].toLocaleString() }) :
												product[column.key] || '-'}
									</TableCell>
								);
							})}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};